import './styles/responsive.scss';
import { tablet, desktop } from './styles/responsive.scss';

const _width = window.innerWidth || window.screen.width;

const _tablet = Number.parseInt(tablet);
const _desktop = Number.parseInt(desktop);
const UA = navigator.userAgent;

// RegEx are from the BillingMobileUtil.java, should keep consistent with it
const _mobileUA = /mobile|android|iphone|phone/i;
const _tabletUA = /ipad/i;

export const isMobile = _mobileUA.test(UA) || (_width < _tablet);
export const isTablet = _tabletUA.test(UA) || (_width >= _tablet && _width < _desktop);
export const isDesktop = _width >= _desktop;

window._billing_responsive = { isMobile, isTablet, isDesktop };
